import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface SessionUser {
  userId: string
  username: string
  rol: string
  numeComplet: string
  punctLucruId: string
  punctCodul: string        // ex. PL0001
  punctDenumire: string     // ex. "Depozit Central"
  storeDbId: string
  puncteLucruAcces: string[] | null  // null = admin (acces total)
  token: string
}

interface AuthState {
  session: SessionUser | null
  setSession: (s: SessionUser | null) => void
  logout: () => void
}

/**
 * Rolul `vizualizare` este read-only, iar backendul îi refuză ORICE mutație
 * (readOnlyGuard din `protectedProcedure`). Interfața afișa însă toate butoanele de
 * creare/editare/ștergere, deci utilizatorul le apăsa și primea o eroare garantată.
 * Folosește-l ca să ascunzi acțiunile, nu ca graniță de securitate — aceea e pe server.
 */
export function usePoateModifica(): boolean {
  const rol = useAuthStore(s => s.session?.rol)
  return rol !== 'vizualizare'
}

// La logout trebuie golit și cache-ul React Query, altfel datele utilizatorului anterior
// (sau ale punctului de lucru anterior) rămân vizibile pentru următoarea sesiune. queryClient
// trăiește în App.tsx (nu se poate importa aici fără ciclu) → îl înregistrăm printr-un callback.
let onLogoutCleanup: (() => void) | null = null
export function registerLogoutCleanup(fn: () => void) { onLogoutCleanup = fn }

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      session: null,
      setSession: (s) => {
        if (s) localStorage.setItem('token', s.token)
        else localStorage.removeItem('token')
        set({ session: s })
      },
      logout: () => {
        localStorage.removeItem('token')
        localStorage.removeItem('fileToken')
        set({ session: null })
        onLogoutCleanup?.()
      },
    }),
    { name: 'auth-session', partialize: (s) => ({ session: s.session }) },
  ),
)
